import { usePlayerActions } from "@utils/player/core/usePlayer";
import type { Song as SongType } from "@libs/wire";
import LBox from "@components/LBox";
import LText from "@components/LText";
import Song from "@components/Song";
import { useCallback } from "react";

type Artist = {
  id: string;
  name: string;
};

interface PopularSongsProps {
  artist: Artist;
  songs: SongType[];
}

const PopularSongs = ({ artist, songs }: PopularSongsProps) => {
  const playerActions = usePlayerActions();

  const playFromCollection = playerActions.playFromCollection;
  const onPress = useCallback(
    (song: SongType) => {
      playFromCollection({
        songId: song.id,
        collectionType: "artist",
        collectionId: artist.id,
        collectionName: artist.name,
        songs,
      });
    },
    [artist.id, artist.name, playFromCollection, songs],
  );

  if (songs.length === 0) {
    return null;
  }

  return (
    <LBox gap="m1" mb="m1">
      <LText variant="Heading/H1/Bold">Popular</LText>
      {songs.map((song, index) => (
        <LBox key={song.id}>
          <Song
            catalogSong={song}
            collectionId={artist.id}
            collectionType="artist"
            key={song?.id || index}
            onPress={onPress}
            showArtwork
            trackNumber={index + 1}
          />
        </LBox>
      ))}
    </LBox>
  );
};

export default PopularSongs;
